import React from 'react';
import { useNavigate } from 'react-router-dom';

import BlockEventSingleRuleGroup from '@components/block-event-single/components/BlockEventSingleRuleGroup';
import { BlockRuleTypeOptions } from '@components/block-event-single/constant/constant';
import {
  EPanelOpenMethod,
  useBlockEventSinglePanelStore,
} from '@components/block-event-single/store';
import MappingRulesExplorer from '@components/detail-panel/components/EventMappingRules/MappingRulesExplorer';
import { IBlockRules } from '@components/detail-panel/components/EventMappingRules/typed';
import { useTopPanelStore } from '@hooks';

const BlockedRules: React.FC<IBlockRules> = ({
  mode,
  data,
  blockType,
  onChange,
  onBlockRulesChange,
  onBlockTypeChange,
}) => {
  const navigate = useNavigate();

  const [setPanelOpenMethod, setBlockType, setBlockEventsSingleDataGroup] =
    useBlockEventSinglePanelStore((state) => [
      state.setPanelOpenMethod,
      state.setBlockType,
      state.setBlockEventsSingleDataGroup,
    ]);
  const { openBlockEventSinglePanel } = useTopPanelStore();

  const handleClickViewButton = () => {
    if (data) {
      setPanelOpenMethod(EPanelOpenMethod.EDIT);
      openBlockEventSinglePanel();
      if (data?.[0]?.block_rules?.length > 0) {
        setBlockType(BlockRuleTypeOptions[1].value);
      } else {
        setBlockType(BlockRuleTypeOptions[0].value);
      }
      setBlockEventsSingleDataGroup([data]);
      navigate(`/semantic-mapper`);
    }
  };
  return (
    <div>
      <MappingRulesExplorer
        mode={mode}
        title="Block Rules"
        buttonText="View in Block Panel"
        onClick={handleClickViewButton}
      />
      <BlockEventSingleRuleGroup
        key={`ManagementBlockRules_${0}`}
        index={0}
        mode={mode}
        data={data}
        blockType={blockType}
        onChange={(...rest) => onChange?.(...rest)}
        onBlockRulesChange={onBlockRulesChange}
        onBlockTypeChange={(value) => onBlockTypeChange?.(value)}
      />
    </div>
  );
};

export default BlockedRules;
